import axios from "axios";
import request from "./request";
import ORIGINS from "@/config/origins";
const activeid = "260911";

const getOrigin = () => {
    const pathname = window.location.pathname
            .toLocaleLowerCase()
            .replace("index.html", ""),
        device = CsGame.isPc() ? "" : "移动端";
    if (pathname.length < 10) {
        return ORIGINS[0]["name"] + device;
    }
    const find = ORIGINS.find((item) => {
        return item["pathname"] == pathname;
    });
    if (find) {
        return find["name"] + device;
    }
    return ORIGINS[0]["name"] + device;
};

// 获取页面状态
export function GetStatus() {
    return request({
        url: "/Api/GetOpen.ashx",
        params: {
            code: activeid
        }
    });
}

// 信息加载
export function GetMyInfo() {
    return request({
        url: "/api/2026/0911/Load.ashx"
    });
}

// 预约
export function SignUp() {
    return request({
        method: "post",
        url: "/api/2026/0911/Yuyue.ashx",
        data: {
            channel: getOrigin()
        }
    });
}

// 预约总数
export function GetAmount() {
    return request({
        url: "/api/2026/0911/GetYuyueAmount.ashx"
    });
}

// 角色列表
export function GetRoles() {
    return request({
        url: "/api/2026/0911/GetRoleList.ashx"
    });
}

// 角色绑定
export function BindRole(rolename) {
    return request({
        url: "/api/2026/0911/BindRole.ashx",
        method: "post",
        data: { rolename, channel: getOrigin() }
    });
}

// 兄弟团榜
export function GetBrothers(page, limit) {
    return request({
        url: "/api/2026/0911/GetTeamRank.ashx",
        params: { page, limit }
    });
}

// 查询指定兄弟团成员列表
export function GetSearchBrother(search) {
    return request({
        url: "/api/2026/0911/GetTeamInfo.ashx",
        params: { search }
    });
}

// 创建队伍
export function CreateTeam(team_name) {
    return request({
        method: "post",
        url: "/api/2026/0911/CreateTeam.ashx",
        data: { team_name }
    });
}

// 加入队伍
export function JoinTeam(team_id) {
    return request({
        method: "post",
        url: "/api/2026/0911/JoinTeam.ashx",
        data: { team_id }
    });
}

// 退出队伍
export function QuitTeam() {
    return request({
        url: "/api/2026/0911/ExitTeam.ashx"
    });
}

// 解散队伍
export function DisbandTeam() {
    return request({
        url: "/api/2026/0911/DisbandTeam.ashx"
    });
}

// 抽奖
export function Lottery() {
    return request({
        method: "post",
        url: "/api/2026/0911/Lottery.ashx"
    });
}

// 我的获奖日志
export function GetMyRewards() {
    return request({
        url: "/api/2026/0911/GetLotteryLog.ashx"
    });
}

// 滚动信息
export function GetSpeakers() {
    return request({
        url: "/api/2026/0911/GetAllLotteryLog.ashx"
    });
}

// 新闻详情
export function GetNewsDetail(newsId) {
    return new Promise((resolve) => {
        axios({
            url: "https://csapi.web.sdo.com/news/xyx/info",
            params: {
                newsId
            }
        }).then((res) => {
            if (res.data.code == "10000") {
                resolve(res.data.data);
            } else {
                return CsLib.alert(res.data.msg, 1200, "error");
            }
        });
    });
}
